import { render, staticRenderFns } from "./FreePicklsPopup.vue?vue&type=template&id=922905c8&scoped=true&"
import script from "./FreePicklsPopup.vue?vue&type=script&lang=ts&"
export * from "./FreePicklsPopup.vue?vue&type=script&lang=ts&"
import style0 from "./FreePicklsPopup.vue?vue&type=style&index=0&id=922905c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922905c8",
  null
  
)

export default component.exports